import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { LogIn, Eye, DollarSign, ArrowRight } from 'lucide-react';
import { base44 } from '@/api/base44Client';

export default function AccessDenied() {
  const navigate = useNavigate();

  const handleLogin = () => {
    // Redirects to the login page provided by Base44 platform
    base44.auth.redirectToLogin();
  };

  const handleExploreFeatures = () => {
    // Navigates to the Landing page and scrolls to the #features section
    navigate('/#features');
  };

  const handleViewPricing = () => {
    // Navigates to the Landing page and scrolls to the #pricing section
    navigate('/#pricing');
  };

  return (
    <div className="min-h-screen bg-[#0F172A] flex items-center justify-center text-white p-4">
      <div className="text-center glass p-10 rounded-2xl max-w-lg">
        <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r from-[#06B6D4] to-[#10B981] bg-clip-text text-transparent">
          Access Restricted
        </h1>
        <p className="text-[#94A3B8] mb-8 text-lg">
          It looks like you're trying to access a protected page. Log in or sign up to unlock the full power of NimbleNode!
          You can also explore our features and pricing plans first.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            onClick={handleLogin}
            className="bg-[#06B6D4] hover:bg-[#0891B2] text-white text-lg px-8 py-4 font-semibold"
          >
            <LogIn className="w-5 h-5 mr-2" />
            Login or Sign Up
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
          <Button
            onClick={handleExploreFeatures}
            variant="outline"
            className="glass hover:bg-[#334155] text-white border-[#334155] text-lg px-8 py-4"
          >
            <Eye className="w-5 h-5 mr-2" />
            Explore Features
          </Button>
          <Button
            onClick={handleViewPricing}
            variant="outline"
            className="glass hover:bg-[#334155] text-white border-[#334155] text-lg px-8 py-4"
          >
            <DollarSign className="w-5 h-5 mr-2" />
            View Pricing
          </Button>
        </div>
      </div>
    </div>
  );
}